'use strict';


function makeAnswer(settings) {
    var answer = {};
    answer.text = settings.text;
    answer.nextQuestion = settings.nextQuestion;
    answer.attrPoints = settings.attrPoints || [];

    return answer;
}

function makeQuestion(settings) {
    var question = {};

    question.queryID = settings.queryID;
    question.queryText = settings.queryText;
    question.skipTo = settings.skipTo;
    question.answers = []; // = settings.answers;
    question.why = settings.why;

    settings.answers.forEach(function(answer) {
        var formattedAnswer = makeAnswer(answer);
        question.answers.push(formattedAnswer);
    });

    question.getQueryText = function() {
        return question.queryText;
    };

    var questionAPI = {
        get queryID() {
            return question.queryID;
        },
        getWhy: function() {
            var whyText = '';
            if (question.why) {
                whyText = question.why;
            }
            return whyText;
        },
        get answers() {
            return question.answers;
        },
        get skipTo() {
            return question.skipTo;
        },
        get isGroup() {
            return false;
        },
        getQueryText: function(isPersonal) {
            if (isPersonal === true) {
                return question.queryTextPersonal;
            } else {
                return question.queryText;
            }
        },
        get numberOfAnswers() {
            return question.answers.length;
        },

        getAnswerText: function(index) {
           return question.answers[index].text;
        },
        get attributesAffected() {
            var attributes = [];
            question.answers.forEach(function(answer) {
                answer.attrPoints.forEach(function(attr) {
                    attributes.push(attr.attr);
                });
            });
            return attributes;
        }
    };

    return questionAPI;
}

function makeQuestionGroup(settings) {
    var queryID = settings.queryID;
    var queryText =  settings.queryText; //set to business if there is one, else default
    var nextQuestion = settings.nextQuestion;
    var questions = settings.questions;
    var why = settings.why;


    var groupAPI = {
        get queryID() {
            return queryID;
        },
        getWhy: function() {
            var whyText = '';
            if (why) {
               whyText = why;
            }
            return whyText;
        },
        get isGroup() {
            return true;
        },
        get questions() {
            return questions;
        },
        getQueryText: function() {
           return queryText;
        },
        get nextQuestion() {
            return nextQuestion;
        },
        get attributesAffected() {
            var attributes = [];
            questions.forEach(function(question) {
                question.answers.forEach(function(answer) {
                    answer.attrPoints.forEach(function(attr) {
                        attributes.push(attr.attr);
                    });
                });
            });
            return attributes;
        }
    };

    return groupAPI;

}

//Individual Questions...
//////////////////////////////////////////////////////////////////////////////
/////////////////////// PERSONAL QUESTION 1 //////////////////////////////////
var questionGender = makeQuestion({
    queryID: 'gender',
    queryText: 'Gender',
    why: '', //none, this is part of a group
    answers: [{
        text: 'Male'
    }, {
        text: 'Female'
    },, {
        text: 'Prefer not to respond'
    }]
});
var questionWeight = makeQuestion({
    queryID: 'weight',
    queryText: 'Weight',
    why: '',//none, this is part of a group
    // answers: [{
    //     text: 'Up to 100 pounds.'
    // }, {
    //     text: '100-300 pounds.',
    //     attrPoints: [{
    //         attr: 'weight',
    //         value: 0
    //     }]
    // }, {
    //     text: 'Greater than 300 pounds',
    //     attrPoints: [{
    //         attr: 'weight',
    //         value: 10
    //     }]
    // }]
    answers: [{
        text: 'Under 300 pounds',
        attrPoints: [{
            attr: 'weight',
            value: 0
        }]
    }, {
        text: 'Over 300 pounds',
        attrPoints: [{
            attr: 'weight',
            value: 10
        }]
    },{
        text: 'Prefer not to respond'
    }]
});
// Under 300 pounds
// Over 300 pounds
// Prefer not to respond
var questionHeight = makeQuestion({
    queryID: 'height',
    queryText: 'Height',
    why: '',//none, this is part of a group
    answers: [{
        text: 'Less than 5’',
        attrPoints: [{
            attr: 'height_accomodation',
            value: 3
        }]
    }, {
        text: '5’-6’',
        attrPoints: [{
            attr: 'height_accomodation',
            value: 0
        }]
    }, {
        text: 'Greater than 6’',
        attrPoints: [{
            attr: 'height_accomodation',
            value: 3
        }]
    }]
});
var valuePersonalGroup = makeQuestionGroup({
    queryID: 'personal',
    queryText: '<span class="mobile-line-break">Let’s start with</span> <span class="mobile-line-break">the basics.</span>',

    why: 'A chair should fit the body like a piece of clothing. To help us tailor our recommendations for you, we need a general sense of your size and shape.',

    questions: [questionGender, questionHeight, questionWeight]
});
//////////////////////////////////////////////////////////////////////////////
/////////////////////// PERSONAL QUESTION 2 //////////////////////////////////

var questionDuration = makeQuestion({
    queryID: 'duration',
    queryText: 'How much time will you spend in your chair each day?',

    why: 'Each Herman Miller chair delivers a unique combination of immediate and lasting comfort. We want you to have the support you need for as long as you sit.',
    answers: [{
        text: 'Up to 2 hours',

        attrPoints: [{
            attr: 'sit_duration',
            value: 1
        }]
    }, {
        text: 'Between 2 and 4 hours',

        attrPoints: [{
            attr: 'sit_duration',
            value: 5
        }]
    }, {
        text: 'More than 4 hours',

        attrPoints: [{
            attr: 'sit_duration',
            value: 10
        }]
    }]
});
//////////////////////////////////////////////////////////////////////////////
/////////////////////// PERSONAL QUESTION 3 //////////////////////////////////

var questionSitType = makeQuestion({
    queryID: 'sittype',
    queryText: 'What is your most common posture—the position of your body as you&nbsp;sit?',
    why: 'Those teachers who told you to sit up straight had the right idea, but today’s high-performance office chairs can support a variety of work postures.',
    answers: [{
        text: 'I like to lean back and work while reclined',
        attrPoints: [{
            attr: 'balanced_recline',
            value: 10
        }]
    }, {
        text: 'I change positions often',
        attrPoints: [{
            attr: 'mobility',
            value: 10
        }]
    }, {
        text: 'I sit up straight most of the time',
        attrPoints: [{
            attr: 'balanced_recline',
            value: 4
        }]
    }]
});
//////////////////////////////////////////////////////////////////////////////
/////////////////////// PERSONAL QUESTION 4 //////////////////////////////////

var questionStool = makeQuestion({
    queryID: 'stool',
    queryText: 'At what type of desk will this chair&nbsp;be&nbsp;used?',

    why: 'By providing a choice of stools as well as high-performance office chairs, Herman Miller seating accommodates a variety of work surface heights.',
    answers: [{
        text: 'Stationary desk or table (lower than 32.5 inches)',

        attrPoints: [{
            attr: 'seat_height',
            value: 1
        }]
    }, {
        text: 'Sit-to-stand desk or table (height-adjustable)',

        attrPoints: [{
            attr: 'seat_height',
            value: 1
        }]
    }, {
        text: 'Standing-height desk or counter (higher than 32.5 inches)',

        attrPoints: [{
            attr: 'seat_height',
            value: 10
        }]
    }]
});

//////////////////////////////////////////////////////////////////////////////
/////////////////////// PERSONAL QUESTION 5 //////////////////////////////////

var questionAdjustability = makeQuestion({
    queryID: 'adjustability',
    queryText: 'Adjustability',
    why: 'A range of adjustment options are available on many chairs, including seat height, seat depth, tilt tension, arm height, arm width, and more.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'adjustability',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'adjustability',
            value: 6
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'adjustability',
            value: 10
        }]
    }]
});
var questionBackSupport = makeQuestion({
    queryID: 'support',
    queryText: 'Back Support',
    why: 'When you sit, the muscles of your back works hard to hold your body upright. The design of your chair can help. Many Herman Miller chairs deliver proper support for the natural curve of your spine, which is key to preventing stress and strain as you sit.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'backsupport',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'backsupport',
            value: 6
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'backsupport',
            value: 10
        }]
    }]
});
var questionBreathable = makeQuestion({
    queryID: 'breathability',
    queryText: 'Breathable Materials',
    why: 'People often associate feeling hot with feeling uncomfortable, so many Herman Miller chairs are available with breathable materials that help you keep an even body temperature.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'breathability',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'breathability',
            value: 5
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'breathability',
            value: 10
        }]
    }]
});
var questionVariety = makeQuestion({
    queryID: 'variety',
    queryText: 'Color and Material Choices ',
    why: 'Our material offerings range from subtle and sophisticated to vibrant and energetic.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'color_variety',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'color_variety',
            value: 5
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'color_variety',
            value: 10
        }]
    }]
});
var valueQuestionGroup = makeQuestionGroup({
    queryID: 'value',
    queryText: 'Which attributes from the following list do you value in a chair?',
    nextQuestion: 'complete',
    why: 'Now that we know a little about you and your work, help us fine-tune our recommendations.',
    questions: [questionAdjustability, questionBackSupport, questionBreathable, questionVariety]
});

//////////////////////////////////////////////////////////////////////////////
/////////////////////// BUSINESS QUESTION 1 //////////////////////////////////
var questionWorkSpaceBusiness = makeQuestion({
    queryID: 'workspace_business',
    queryText: 'Where will employees be using this chair?',
    why: 'The more people who will use a chair throughout the day, the more important it is that the chair adjustments are easy and intuitive.',
    answers: [{
        text: 'At an individual desk',
        attrPoints: [{
            attr: 'adjustability',
            value: 10
        }]
    }, {
        text: 'At a shared workspace',
        attrPoints: [{
            attr: 'adjustability',
            value: 2
        }]
    }, {
        text: 'In a group space or conference room',
        attrPoints: [{
            attr: 'adjustability',
            value: 2
        }]
    }]
});

//////////////////////////////////////////////////////////////////////////////
/////////////////////// BUSINESS QUESTION 2 //////////////////////////////////
var questionDurationBusiness = makeQuestion({
    queryID: 'duration_business',
    queryText: 'How much time will employees spend in this chair each day?',

    why: 'Each Herman Miller chair delivers a unique combination of immediate and lasting comfort. We want people to have the support they need for as long as they sit.',
    answers: [{
        text: 'Up to 2 hours a day',

        attrPoints: [{
            attr: 'sit_duration',
            value: 1
        }]
    }, {
        text: 'Between 2 and 4 hours a day',

        attrPoints: [{
            attr: 'sit_duration',
            value: 5
        }]
    }, {
        text: 'More than 4 hours a day',

        attrPoints: [{
            attr: 'sit_duration',
            value: 10
        }]
    }]
});

//////////////////////////////////////////////////////////////////////////////
/////////////////////// BUSINESS QUESTION 3 //////////////////////////////////

var questionStoolBusiness = makeQuestion({
    queryID: 'stool_business',
    queryText: 'At what type of desk will this chair&nbsp;be&nbsp;used?',
    why: 'By providing a choice of stools as well as high-performance office chairs, Herman Miller seating accommodates a variety of work surface heights.',
    answers: [{
        text: 'Stationary desk or table (lower than 32.5 inches)',

        attrPoints: [{
            attr: 'seat_height',
            value: 1
        }]
    }, {
        text: 'Sit-to-stand desk or table (height-adjustable)',

        attrPoints: [{
            attr: 'seat_height',
            value: 1
        }]
    }, {
        text: 'Standing-height desk or counter (higher than 32.5 inches)',

        attrPoints: [{
            attr: 'seat_height',
            value: 10
        }]
    }]
});
//////////////////////////////////////////////////////////////////////////////
/////////////////////// PERSONAL QUESTION 4 //////////////////////////////////

var questionAdjustabilityBusiness = makeQuestion({
    queryID: 'adjustability_business',
    queryText: 'Adjustability',
    why: 'A range of adjustment options are available on many chairs, including seat height, seat depth, tilt tension, arm height, arm width, and more.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'adjustability',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'adjustability',
            value: 6
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'adjustability',
            value: 10
        }]
    }]
});
var questionBackSupportBusiness = makeQuestion({
    queryID: 'support_business',
    queryText: 'Back Support',
    why: 'When you sit, the muscles of your back works hard to hold your body upright. The design of your chair can help. Many Herman Miller chairs deliver proper support for the natural curve of your spine, which is key to preventing stress and strain as you sit.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'backsupport',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'backsupport',
            value: 6
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'backsupport',
            value: 10
        }]
    }]
});
var questionBreathableBusiness = makeQuestion({
    queryID: 'breathability_business',
    queryText: 'Breathable Materials',
    why: 'People often associate feeling hot with feeling uncomfortable, so many Herman Miller chairs are available with breathable materials that help you keep an even body temperature.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'breathability',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'breathability',
            value: 5
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'breathability',
            value: 10
        }]
    }]
});
var questionVarietyBusiness = makeQuestion({
    queryID: 'variety_business',
    queryText: 'Color and Material Choices ',
    why: 'Our material offerings range from subtle and sophisticated to vibrant and energetic.',
    answers: [{
        text: 'Somewhat Important',
        attrPoints: [{
            attr: 'color_variety',
            value: 1
        }]
    }, {
        text: 'Important',
        attrPoints: [{
            attr: 'color_variety',
            value: 5
        }]
    }, {
        text: 'Very Important',
        attrPoints: [{
            attr: 'color_variety',
            value: 10
        }]
    }]
});
var valueQuestionGroupBusiness = makeQuestionGroup({
    queryID: 'value_business',
    queryText: 'Which attributes from the following list do you value in a chair?',
    why: 'Now that we know a little about your people and their work, help us fine-tune our recommendations.',
    questions: [questionAdjustabilityBusiness, questionBackSupportBusiness, questionBreathableBusiness, questionVarietyBusiness]
});

//
// var questionCost = makeQuestion({
//     queryID: 'cost',
//     queryText: 'Affordability',
//     why: {
//         personal: '',
//         business: ''
//     },
//     answers: [{
//         text: 'Somewhat Important',
//         nextQuestion: 'breathability',
//         attrPoints: [{
//             attr: 'price',
//             value: 1
//         }]
//     }, {
//         text: 'Important',
//         nextQuestion: 'breathability',
//         attrPoints: [{
//             attr: 'price',
//             value: 5
//         }]
//     }, {
//         text: 'Very Important',
//         nextQuestion: 'breathability',
//         attrPoints: [{
//             attr: 'price',
//             value: 10
//         }]
//     }]
// });




// var personalList = [valueQuestionGroup, valuePersonalGroup, questionDuration, questionSitType, questionStool];

var personalList = [valuePersonalGroup, questionDuration, questionSitType, questionStool, valueQuestionGroup];
var businessList = [questionWorkSpaceBusiness, questionDurationBusiness, questionStoolBusiness, valueQuestionGroupBusiness];





var allQuestions = personalList.concat(businessList);



// var list = [questionGender, questionHeight, questionWeight, questionWorkSpace,
//     questionDuration, questionSitType, questionStool, questionBackSupport, questionAdjustability,
//     questionCost, questionAdjustability, valueQuestionGroup, valuePersonalGroup
// ];

var list = personalList;

var questions = {
    setType: function (questionsType) {

        if (questionsType === 'personal') {
            list = personalList;
        } else if (questionsType === 'business'){
            list = businessList;

        } else {
            console.log('error with questionsType:', questionsType);
        }

    },

    get list() {
        return list;
    },
    get allQuestions() {
        return allQuestions;
    },
    getQuestionWithId: function(id) {

        var found = list.reduce(function(a, b) {
            return (a.queryID === id && a) || (b.queryID === id && b);
        });
        return found;
    },

    getQuestionByIndex: function(index) {
        return list[index];
    },

    getAttributesAffectedByQuestion: function(questionId) {
        var question = list.reduce(function(a, b) {
            return (a.queryID === questionId && a) || (b.queryID === questionId && b);
        });
        return question.attributesAffected;
    },

    getSkipToFrom: function(questionId) {
        var question = list.reduce(function(a, b) {
            return (a.queryID === questionId && a) || (b.queryID === questionId && b);
        });

        return question.skipTo;
    }



};

module.exports = questions;
